// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3HLv4","actionsCol":"EnrolledClinics_actionsCol__3xUsp"};